import React from "react";
import ChatRoom from "./components/ChatRoom";
import SignIn from "./components/SignIn";
import { auth } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import "./App.css";

export default function App() {
  const [user] = useAuthState(auth);
  return <>{user ? <ChatRoom /> : <SignIn />}</>;
}
